module.exports = __webpack_public_path__ + "static/media/discover_img_1.9c5394c1.jpg";